import { render, staticRenderFns } from "./EquipPointList.vue?vue&type=template&id=58bd5f00"
import script from "./EquipPointList.vue?vue&type=script&lang=js"
export * from "./EquipPointList.vue?vue&type=script&lang=js"
import style0 from "./EquipPointList.vue?vue&type=style&index=0&id=58bd5f00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports